import * as jose from 'jose';
import { getAuth } from 'firebase/auth';


class WedifyApiRequest {
    constructor() {
        if (WedifyApiRequest.instance) {
            return WedifyApiRequest.instance;
        }
        this.clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
        this.clientSecret = process.env.REACT_APP_COGNITO_CLIENT_SECRET;
        this.jwksUri = process.env.REACT_APP_COGNITO_JWKS_URI;
        this.tokenEndpoint = process.env.REACT_APP_COGNITO_TOKEN_ENDPOINT;
        this.accessToken = null;
        this.tokenExpiration = null;

        WedifyApiRequest.instance = this;
    }

    static getInstance() {
        if (!WedifyApiRequest.instance) {
            WedifyApiRequest.instance = new WedifyApiRequest();
        }
        return WedifyApiRequest.instance;
    }

    // Helper function to verify token
    async verifyToken(token) {
        try {
            const JWKS = jose.createRemoteJWKSet(new URL(this.jwksUri));
            const { payload } = await jose.jwtVerify(token, JWKS);
            return payload;
        } catch (error) {
            throw error;
        }
    }

    async getAccessToken() {
        // Check if we have a valid token
        if (this.accessToken && this.tokenExpiration && Date.now() < this.tokenExpiration) {
            return this.accessToken;
        }

        try {
            const params = new URLSearchParams();
            params.append('grant_type', 'client_credentials');
            params.append('scope', 'default-m2m-resource-server-nncxeg/read');

            const authString = btoa(`${this.clientId}:${this.clientSecret}`);

            const response = await fetch(this.tokenEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': `Basic ${authString}`
                },
                body: params
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            this.accessToken = data.access_token;

            this.tokenExpiration = Date.now() + (data.expires_in * 1000);
            await this.verifyToken(this.accessToken);

            return this.accessToken;
        } catch (error) {
            throw error;
        }
    }

    async makeRequest(endpoint, method = 'GET', body = null, additionalHeaders = null) {
        const token = await this.getAccessToken();
        const isLoginEndpoint = endpoint.includes('api/login/addUser');
        const isUploadEndpoint = endpoint.includes('api/images/upload/auth/id');

        
        // Initialize headers with token
        const headers = {
            'X-Auth-Token': token,
        };

        if (!isUploadEndpoint) {
            headers['Content-Type'] = 'application/json';
        }

        if (!isLoginEndpoint) {
            const auth = getAuth();
            const currentUser = auth.currentUser;
            
            if (!currentUser) {
                return;
            }

            // Don't add user-related headers for email modification endpoint
            if (!endpoint.includes('api/login/users/modify/email')) {
                headers['externalClientId'] = currentUser.uid;
            }        
            headers['authenticationService'] = 'firebase';
        }

        const requestOptions = {
            method,
            headers: { ...headers, ...additionalHeaders },
            body
        };

        try {
            const response = await fetch(endpoint, requestOptions);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response;
        } catch (error) {
            throw error;
        }
    }
}

export default WedifyApiRequest;
